export default "__VITE_ASSET__VRS7dCsH__"